import { cva } from 'class-variance-authority';

import s from './Wrapper.module.css';

export const wrapperVariants = cva(s.wrapper, {
  defaultVariants: {
    hasPrefix: false,
    hasSuffix: false,
    size: 'default',
    variant: 'default',
  },
  variants: {
    disabled: {
      true: s['wrapper--disabled'],
    },
    fullWidth: {
      true: s['wrapper--full-width'],
    },
    hasPrefix: {
      false: s['wrapper--no-prefix'],
      true: s['wrapper--has-prefix'],
    },
    hasSuffix: {
      false: s['wrapper--no-suffix'],
      true: s['wrapper--has-suffix'],
    },
    size: {
      default: s['wrapper--size-default'],
      large: s['wrapper--size-large'],
    },
    variant: {
      accent: s['wrapper--variant-accent'],
      danger: s['wrapper--variant-danger'],
      default: s['wrapper--variant-default'],
      success: s['wrapper--variant-success'],
    },
  },
});
